export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'month', label: '月份', minWidth: '60'},
    {prop: 'thirdParty', label: '归属', minWidth: '70'},
    {prop: 'channelName', label: '来源直播间', minWidth: '80'},
    {prop: 'teacherName', label: '对应老师', minWidth: '60'},
    {prop: 'resourceCount', label: '资源数', minWidth: '70', sortable: true},
    {prop: 'repeatRate', label: '重复率', minWidth: '80', sortable: true, slotName: 'repeatRate'},
    {prop: 'deleteRate', label: '24小时删除率', minWidth: '80', sortable: true, slotName: 'deleteRate'},
    {prop: 'effectiveCount', label: '有效资源数', minWidth: '80', sortable: true},
    {prop: 'dealCount', label: '成交单量', minWidth: '80', sortable: true},
    {prop: 'dealAmount', label: '开单总金额', minWidth: '80', sortable: true},
    {prop: 'developRate', label: '开发率', minWidth: '80', sortable: true, slotName: 'developRate'},
    {prop: 'roi', label: 'ROI', minWidth: '80', sortable: true, slotName: 'roiRate'},
    {label: '操作', minWidth: '60', slotName: 'handler'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
